export var NotebookCell;
(function (NotebookCell) {
    NotebookCell["content"] = "notebook-content";
    NotebookCell["code"] = "notebook-code";
})(NotebookCell || (NotebookCell = {}));
export var NotebookCellTags;
(function (NotebookCellTags) {
    NotebookCellTags["removeStderr"] = "remove-stderr";
    NotebookCellTags["removeStdout"] = "remove-stdout";
    NotebookCellTags["hideCell"] = "hide-cell";
    NotebookCellTags["hideInput"] = "hide-input";
    NotebookCellTags["hideOutput"] = "hide-output";
    NotebookCellTags["removeCell"] = "remove-cell";
    NotebookCellTags["removeInput"] = "remove-input";
    NotebookCellTags["removeOutput"] = "remove-output";
})(NotebookCellTags || (NotebookCellTags = {}));
// Types for defining roles and directives
export var ParseTypesEnum;
(function (ParseTypesEnum) {
    ParseTypesEnum["string"] = "string";
    ParseTypesEnum["number"] = "number";
    ParseTypesEnum["boolean"] = "boolean";
    ParseTypesEnum["parsed"] = "parsed";
})(ParseTypesEnum || (ParseTypesEnum = {}));
export var TargetKind;
(function (TargetKind) {
    TargetKind["heading"] = "heading";
    TargetKind["equation"] = "equation";
    TargetKind["subequation"] = "subequation";
    TargetKind["figure"] = "figure";
    TargetKind["table"] = "table";
    TargetKind["code"] = "code";
})(TargetKind || (TargetKind = {}));
export var AdmonitionKind;
(function (AdmonitionKind) {
    AdmonitionKind["admonition"] = "admonition";
    AdmonitionKind["attention"] = "attention";
    AdmonitionKind["caution"] = "caution";
    AdmonitionKind["danger"] = "danger";
    AdmonitionKind["error"] = "error";
    AdmonitionKind["important"] = "important";
    AdmonitionKind["hint"] = "hint";
    AdmonitionKind["note"] = "note";
    AdmonitionKind["seealso"] = "seealso";
    AdmonitionKind["tip"] = "tip";
    AdmonitionKind["warning"] = "warning";
})(AdmonitionKind || (AdmonitionKind = {}));
